import React from 'react'
import { useTranslation } from 'react-i18next'
import { Stack, Grid2 as Grid } from '@mui/material'

import GasVault from './GasVault'
import { useOutletContext } from 'react-router-dom'
import { gasDetecorMetadata } from 'Shared/constant'

const GasMonitor = ({ data, threshold }) => {
  const { t } = useTranslation()
  const { projectInfo } = useOutletContext()

  return (
    <div style={{ width: "100%", height: "100%", backgroundColor: "#FFFFFF", borderRadius: "10px", display: "flex", flexDirection: "column", overflow: "auto", padding: "10px" }}>
      <Stack direction="row" sx={{ justifyContent: "space-between" }}>
        <div><b>{t("module_gasDetector")}</b></div>
        {data ? (
          <div><b>Last Update: {data["last_update"]}</b></div>
        ) : (
          <div></div>
        )}
      </Stack>

      <div style={{ marginTop: "auto", marginBottom: "auto" }}>
        {data ? (
          <div style={{ width: "100%", padding: "10px" }}>
            <Grid container spacing={2}>
              {projectInfo["info"]["gas"]["gas_types"].map((i) => <>
                <Grid item size={{ xs: 3 }}>
                  <GasVault data={threshold[i]} type={i} value={data[i]["value"]} label={t(gasDetecorMetadata[i]["label"])} unit={gasDetecorMetadata[i]["unit"]} alert={data[i]["alert"]} />
                </Grid>
              </>)}
            </Grid>
          </div>
        ) : (
          <div style={{ width: "100%", flexGrow: 1, display: "flex", flexDirection: "column", overflow: "auto", alignItems: "center", justifyContent: "center" }}>
            <div><b>{t("general_noInfo")}</b></div>
          </div>
        )}
      </div>
    </div>
  )
}

export default GasMonitor
